import { FunctionComponent } from 'react';

interface HeaderProps {
  title: string;
  subtitle: string;
}

export const Header: FunctionComponent<HeaderProps> = ({ title, subtitle }) => (
  <div className="flex flex-col w-full xl:w-5/6 px-6 xl:px-0 pb-6 font-opensans">
    <div className="w-full">
      <span className="text-3xl font-thin text-primary-800 font-bold">
        {title}
      </span>
    </div>
    <div className="w-full mt-2">
      <span className="text-xs text-slate-700">{subtitle}</span>
    </div>
  </div>
);
